import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-summary-select-field',
  templateUrl: './summary-select-field.component.html',
  styleUrls: ['./summary-select-field.component.scss']
})
export class SummarySelectFieldComponent {

  @Input() element: any;

  getSelectedElements() {
    return this.element.selections.filter((selection: any) => selection.selected);
  }

  getSelectionName(selection: any) {
    return selection.name;
  }

  getCustomLabel() {
    return `${this.element.label} - ${this.element.values[0].typeLabel.name}`;
  }
}
